import { IPermissionProps } from '@/types/shared'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import GokuDataGrid from '@/components/GokuDataGrid'
import AddIcons from '@/icons/AddIcons'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import useDataGridRefetch from '@/hooks/useDataGridRefetch'
import { useTranslation } from 'react-i18next'
import { deleteJobCategory, getJobCategories } from '../../services'
import { useConfirmation } from '@/contexts/confirmation'
import SubHeaders from '@/components/Headers/SubHeaders'
import { JobCategoryColumns } from './column'
import EditIcons from '@/icons/EditIcons'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
const List: React.FC<IPermissionProps> = () => {
    const { t: t } = useTranslation()
    const navigate = useNavigate()
    const { setConfirmation } = useConfirmation()
    const jobCategoriesRefetch = useDataGridRefetch({
        reactQueryKey: 'job-categories',
    })
    const { mutateAsync: doDeleteJobCategory, isPending: inDeleteProcessing } =
        useMutationWithHandler(
            {
                mutationFn: deleteJobCategory,
            },
            {
                reactQueryKeys: QUERY_KEYS.JOBS,
                successMessage: t('delete-success'),
                onSuccess: () => {
                    jobCategoriesRefetch.refetchCurrent()
                },
            }
        )
    const deleteCategoryJob = true
    return (
        <div>
            <SubHeaders
                actions={[
                    {
                        label: t('create'),
                        onClick: () => navigate('/job-categories/new'),
                        variant: 'contained',
                        icon: <AddIcons />,
                    },
                    {
                        label: t('job-information'),
                        onClick: () => navigate('/jobs'),
                        variant: 'outlined',
                    },
                ]}
                breadcrumbs={[
                    {
                        path: '/job-categories',
                        title: t('job-categories-list'),
                    },
                ]}
            />
            <GokuDataGrid
                apiCall={getJobCategories}
                columns={JobCategoryColumns}
                reactQueryKey="job-categories"
                dataGridProps={{
                    getRowId: (row) => row?.id,
                }}
                actions={[
                    {
                        onClick: (row) => {
                            navigate(`/job-categories/${row?.id}`)
                        },
                        title: t('edit'),
                        color: 'info',
                        icon: <EditIcons />,
                        disabled: () => inDeleteProcessing,
                    },
                    {
                        onClick: (row) => {
                            setConfirmation({
                                open: true,
                                title: t('job-category-title-delete'),
                                description: `${t('job-category-description-delete')} "${row?.title}"?`,
                                onConfirm: () => doDeleteJobCategory(row?.id),
                            })
                        },
                        title: t('delete'),
                        color: 'error',
                        icon: <DeleteOutlineIcons />,
                        disabled: () =>
                            !deleteCategoryJob || inDeleteProcessing,
                    },
                ]}
            />
        </div>
    )
}

export default List
